import { MultisidebarItem } from '@/store/multisidebar/types';
import { ItemViewModel } from '@/definitions/view-models';
import { Webhook } from '@/api';

export default async function ({ model }: MultisidebarItem<ItemViewModel<Webhook>>) {
  return { label: model.item?.name || '' };
}
